import { useQuery } from 'react-query';
import axios from 'axios';
import { MonitorQueueAPI } from '../../constants/API';
import { getMonitorBranchCode, getMonitorToken, queueScreenHeaders } from '../../constants/HeadersAPI';

export type CreatedTicketItem = {
  itemId: number;
  itemName: string;
  status: string;
  statusTime: string;
};

export type CreatedTicketsResponse = {
  items: CreatedTicketItem[];
};

export const useGetCreatedTickets = () => {
  const {
    data: createdTicketsResp,
    isLoading: isLoadingCreatedTickets,
    isSuccess: isCreatedTicketsReceived
  } = useQuery(
    ['monitor-created-tickets', getMonitorToken(), getMonitorBranchCode()],
    () => axios.get<CreatedTicketsResponse>(MonitorQueueAPI.getCreatedItems, queueScreenHeaders()),
    {
      select: ({ data }) => data,
      enabled: !!getMonitorToken(),
      refetchInterval: 4000
    }
  );

  return { createdTicketsResp, isLoadingCreatedTickets, isCreatedTicketsReceived };
};
